var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Reenviar" : "Cadastrar") + " Notificação ")], 1)]), _c('div', {
    staticClass: "container dialog mt-7"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assunto da Notificação*",
      "maxLength": "40",
      "counter": "40",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 40);
      }]
    },
    model: {
      value: _vm.content.assunto,
      callback: function ($$v) {
        _vm.$set(_vm.content, "assunto", $$v);
      },
      expression: "content.assunto"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Notificação*",
      "maxlength": "500",
      "counter": "500",
      "rows": "3",
      "dense": "",
      "outlined": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 500);
      }]
    },
    model: {
      value: _vm.content.notificacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "notificacao", $$v);
      },
      expression: "content.notificacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12
    }
  }, [_c('v-select', {
    attrs: {
      "item-text": "nome",
      "item-value": "id",
      "label": "Grupo(s)*",
      "dense": "",
      "outlined": "",
      "multiple": "",
      "return-object": "",
      "items": _vm.form.lists.grupos,
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.grupos,
      callback: function ($$v) {
        _vm.$set(_vm.content, "grupos", $$v);
      },
      expression: "content.grupos"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": this.edit ? 'Reenviar' : 'Enviar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }